// Book & pay's extras row: the wash's three featured extras as chips, the rest
// behind "See all extras". The three come from the server (`featuredExtras`
// on the wash, config/catalogue/featured_extras.yml); an extra the wash
// already includes is never shown. A chosen extra from the long list stays
// visible beside the three when the list is folded. `extras` are the bookable
// extras, `base` the chosen wash, `services` the selection by id.
export const splitExtras = (extras, base, services) => {
  const inc = (base && base.includes) || []
  const ids = (base && base.featuredExtras) || []
  const list = extras.filter(s => !inc.includes(s.id))
  const featured = ids.map(id => list.find(s => s.id === id)).filter(Boolean)
  const top = featured.concat(list.filter(s => services[s.id] && !featured.includes(s)))
  return { featured, top, rest: list.filter(s => !top.includes(s)) }
}
